export default {
  全部行业分类: '全部行业分类',
  首页: '首页',
  云上展览: '云上展览',
  全球展览: '全球展览',
  国内展览: '国内展览',
  国外展览: '国外展览',
  全球会议: '全球会议',
  国内会议: '国内会议',
  国外会议: '国外会议',
  云展系统: '云展系统',
  企业展品: '企业展品',
  企业名片: '企业云展',
  企业云展: '企业云展',
  招标类型: '招标类型',
  招标地区: '招标地区',
  招标服务: '招标服务',
  现场直播: '现场直播',
  企业直播: '企业直播',
  产业头条: '产业头条',
  资讯服务: '资讯服务',
  营销工具: '营销工具',
  海报制作: '海报制作',
  共享设计: '共享设计',
  展厅模型: '展厅模型',
  工程商: '工程商',
  设计师: '设计师',
  请输入搜索内容: '请输入搜索内容',
  免费发布: '免费发布',
  发布云上展览: '发布云上展览',
  发布线下展览: '发布线下展览',
  发布全球会议: '发布全球会议',

  发布模型: '发布模型',
  发布海报: '发布海报',
  发布展品: '发布展品',

  // 改版的标题
  云会展: '云会展',
  全球展: '全球展',
  云会议: '云会议',
  云企业: '云企业',
  云数据: '云数据',
  云招聘: '云招聘',
  云产品: '云产品',
  云招标: '云招标',
  云直播: '云直播',
  云头条: '云头条',
  云海报: '云海报',
  云设计: '云设计',
  云模型: '云模型',
  云动态: '云动态',
  云展览: '云展览',
  输入关键词寻找: '输入关键词寻找',
  搜索: '搜索',
  数字孪生: '数字孪生',
  大数据获客: '大数据获客',
  人工智能: '人工智能',
  分类目录: '分类目录',
  欢迎来到云展动力: '欢迎来到云展动力',
  云展动力: '云展动力',
  采购需求: '采购需求',
  更多: '更多',
  发布了采购招标需求: '发布了采购招标需求',
}
